<div class="app-c-header" [class.is-logged-out]="isLoggedOut">
  <a href="#" class="app-l-header-logo">
    <img [src]="'PAGE.IMAGES.LOGO' | translate" alt="Flagship Lab Services" />
  </a>
  <h1
    class="app-c-header-title"
    [innerHTML]="'PAGE.TITLES.ASSESSMENT_NAME' | translate"
  ></h1>

  <!-- Profile Section -->
  <div class="app-l-profile-section" *ngIf="!isLoggedOut">
    <div class="app-l-profile-avatar">
      <img src="assets/images/profile-avatar.png" alt="User Avatar" />
    </div>

    <span class="app-l-profile-username">
      {{ loggedInUser.name }}
    </span>

    <div class="account-action">
      <!-- Toggle Button -->
      <button class="app-c-logout-btn" (click)="onLogoClick()">
        <!-- Dropdown icon -->
        <svg
          *ngIf="hasMultipleDepartments; else logoutBtnIcon"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>

        <!-- Logout icon (button fallback) -->
        <ng-template #logoutBtnIcon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
        </ng-template>
      </button>

      <!-- Dropdown -->
      <div class="account-dropdown" *ngIf="showMenu && hasMultipleDepartments">
        <!-- Switch Department -->
        <div class="account-item" (click)="switchAccount()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="17 1 21 5 17 9"></polyline>
            <line x1="21" y1="5" x2="9" y2="5"></line>
            <polyline points="7 23 3 19 7 15"></polyline>
            <line x1="3" y1="19" x2="15" y2="19"></line>
          </svg>

          {{ "PAGE.LABELS.SWITCH_ASSESSSMENT" | translate }}
        </div>

        <div class="account-divider"></div>

        <!-- Logout -->
        <div class="account-item logout" (click)="logout()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>

          {{ "PAGE.LABELS.LOGOUT" | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
